import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { api } from '../utils/api';
import auth from '../utils/auth';
import useSearchParams from '../utils/useSearchParams';

export default () => {
  const history = useHistory();
  const { searchParams } = useSearchParams();

  useEffect(() => {
    // 주소에 로그인 정보(access_token)가 없으면 빈 화면 대신 로그인 화면으로 (10/10 품질 점검)
    if (!searchParams.access_token) {
      history.replace('/auth/login');
      return;
    }
    const login = async () => {
      const {
        data: {
          data: {
            user: { email, phone },
            total_alarm_count,
          },
        },
      } = await api.get('/user', {
        headers: {
          Authorization: `Bearer ${String(searchParams.access_token)}`,
        },
      });
      auth.setPhone(phone);
      auth.setEmail(email);
      auth.setNoticeCount(total_alarm_count);
      auth.setToken(String(searchParams.access_token));
      auth.setRefreshToken(String(searchParams.refresh_token));
      auth.setRememberMe(true);
      history.push('/');
      window.location.reload();
    };
    login();
  }, [searchParams, history]);

  return null;
};
